import React from "react";
import "./preloader.css";

const Preloader = () => {
  return (
    <div className="page-cover">
      <span className="loader"></span>
    </div>
  );
};

export default Preloader;
